<mat-card class="je-card mat-elevation-z6">
  <mat-card-header>
    <div mat-card-avatar>
      <mat-icon>account_circle</mat-icon>
    </div>
    <mat-card-title>{{ account.name }}</mat-card-title>
    <mat-card-subtitle>{{ account.email }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <br />

    <mat-tab-group [selectedIndex]="0" mat-align-tabs="center">
      <mat-tab *ngFor="let year of years">
        <ng-template mat-tab-label>
          <span>{{ year }}</span>
          <mat-icon
            *ngIf="showWarningBadge(year); else hasNoUnpaid"
            class="warning-badge"
            >error</mat-icon
          >
        </ng-template>

        <h3>
          Licenszek
          {{
            yearly[year].length > 0 ? '(' + yearly[year].length + ' db)' : ''
          }}
        </h3>
        <div class="licences">
          <mat-card
            *ngFor="let l of yearly[year]"
            class="licence mat-elevation-z6"
          >
            <mat-card-header>
              <div
                mat-card-avatar
                [ngClass]="{
                  spotify: l.type.id.indexOf('SPOTIFY') != -1,
                  bitdefender: l.type.id.indexOf('BITDEFENDER') != -1
                }"
              ></div>
              <mat-card-title>{{ l.type.description }}</mat-card-title>
              <mat-card-subtitle
                >{{ l.startDate | date : 'yyyy MMM dd' }} -
                {{ l.endDate | date : 'yyyy MMM dd' }}</mat-card-subtitle
              >
              <mat-card-subtitle *ngIf="l.description">{{
                l.description
              }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="half">
                Ár:
                <span id="price"
                  >{{ l.type.priceHuf | currency : 'Ft ' }} ({{
                    l.type.priceEur | currency : '€ '
                  }})</span
                >
              </div>
              <div class="half">
                Teljesítve:
                <mat-icon *ngIf="l.paid; else notPaid" class="green"
                  >check_circle</mat-icon
                >
                <ng-template #notPaid>
                  <mat-icon class="red">error</mat-icon>
                </ng-template>
              </div>
              <div class="half">
                Előfizetés státusza:
                <span *ngIf="l.decision == null">Kérlek, nyilatkozz!</span>
                <span *ngIf="l.decision == true">Aktív / folyamatban</span>
                <span *ngIf="l.decision == false"
                  >Lemondva / megszüntetés alatt</span
                >
              </div>
            </mat-card-content>
            <mat-card-actions>
              <button
                [disabled]="l.decision != null"
                mat-raised-button
                color="primary"
                (click)="continue(l.permaId)"
              >
                FOLYTAT
              </button>
              <button
                [disabled]="l.decision != null"
                mat-raised-button
                color="warn"
                (click)="stop(l.permaId)"
              >
                LEÁLLÍT
              </button>
            </mat-card-actions>
          </mat-card>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
  <mat-card-actions>
    <!--<button mat-button>LIKE</button>-->
    <!--<button mat-button>SHARE</button>-->
  </mat-card-actions>
</mat-card>
